module.exports = __webpack_public_path__ + "static/img/19一种印花机用定位装置.f7f4a76d.jpg";